import { useDrawer } from '@cast/design-system';

import {
  EdgeLocationsListDrawer,
  EdgeLocationsListDrawerProps,
} from './EdgeLocationsListDrawer';

export const useEdgeLocationsListDrawer = () => {
  const { open } = useDrawer();

  return {
    openEdgeLocationsListDrawer: (props: EdgeLocationsListDrawerProps) =>
      open({ component: EdgeLocationsListDrawer, props }),
  };
};
